import { defineProperty as _defineProperty, slicedToArray as _slicedToArray, inherits as _inherits, classCallCheck as _classCallCheck, possibleConstructorReturn as _possibleConstructorReturn, getPrototypeOf as _getPrototypeOf, assertThisInitialized as _assertThisInitialized, objectSpread as _objectSpread, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { withContext, eventBus, getMarginBottomClass, marginBottomLevels } from '@piggybank/core';
import { Consumer } from '../Field/context.js';
import pick from 'lodash/fp/pick';
import isValidInteger from '../../utils/isValidInteger.js';
import { NumberInput } from '../NumberInput/NumberInput.js';
import isBlurringOutsideRefs from '../../utils/isBlurringOutsideRefs.js';
import leftPad from 'left-pad';
import omit from 'lodash/fp/omit';
import styles from './date-input.css.js';

var _maskAddByFormat, _maskRemoveByFormat;

var FORMAT_YYYY = 'YYYY';
var FORMAT_YYYY_REGEX = /(\d{4})/;
var FORMAT_YYYYMM = 'YYYY-MM';
var FORMAT_YYYYMM_REGEX = /(\d{4})-(\d{2})/;
var FORMAT_YYMM = 'YY-MM';
var FORMAT_YYMM_REGEX = /(\d{2})-(\d{2})/;
var FORMAT_YYYYMMDD = 'YYYY-MM-DD';
var FORMAT_YYYYMMDD_REGEX = /(\d{4})-(\d{2})-(\d{2})/;
var KEYCODE_LEFT_ARROW = 37;
var KEYCODE_RIGHT_ARROW = 39;
var KEYCODE_BACKSPACE = 8;
var yearRangeMax = new Date().getFullYear() - 1950;
var maskAddByFormat = (_maskAddByFormat = {}, _defineProperty(_maskAddByFormat, FORMAT_YYYY, function (date) {
  if (!date.year) return '';
  if (date.year.length < 4) return 'incomplete';
  return date.year;
}), _defineProperty(_maskAddByFormat, FORMAT_YYYYMM, function (date) {
  if (!(date.year || date.month)) return '';
  if (date.year.length < 4 || date.month.length < 1) return 'incomplete';
  if (date.month < 1 || date.month > 12) return 'invalid';
  return "".concat(date.year, "-").concat(leftPad(date.month, 2, 0));
}), _defineProperty(_maskAddByFormat, FORMAT_YYMM, function (date) {
  if (!(date.year || date.month)) return '';
  if (date.year.length < 2 || date.month.length < 1) return 'incomplete';
  if (date.month < 1 || date.month > 12) return 'invalid';
  return "".concat(+date.year > yearRangeMax ? '19' : '20').concat(date.year, "-").concat(leftPad(date.month, 2, 0));
}), _defineProperty(_maskAddByFormat, FORMAT_YYYYMMDD, function (date) {
  if (!(date.year || date.month || date.day)) return '';

  if (date.year.length < 4 || date.month.length < 1 || date.day.length < 1) {
    return 'incomplete';
  }

  var day = Number(date.day);
  var month = Number(date.month);
  var year = Number(date.year);
  var dateValidation = new Date();
  dateValidation.setFullYear(year, month - 1, day);

  if (dateValidation.getFullYear() != year || dateValidation.getMonth() != month - 1 || dateValidation.getDate() != day) {
    return 'invalid';
  }

  return "".concat(date.year, "-").concat(leftPad(date.month, 2, 0), "-").concat(leftPad(date.day, 2, 0));
}), _maskAddByFormat);
var maskRemoveByFormat = (_maskRemoveByFormat = {}, _defineProperty(_maskRemoveByFormat, FORMAT_YYYY, function (date) {
  if (!FORMAT_YYYY_REGEX.test(date)) return null;
  return {
    year: date,
    month: '',
    day: ''
  };
}), _defineProperty(_maskRemoveByFormat, FORMAT_YYYYMM, function (date) {
  var result = FORMAT_YYYYMM_REGEX.exec(date);
  if (!result) return null;

  var _result = _slicedToArray(result, 3),
      year = _result[1],
      month = _result[2];

  return {
    year: year,
    month: month,
    day: ''
  };
}), _defineProperty(_maskRemoveByFormat, FORMAT_YYMM, function (date) {
  var result = FORMAT_YYMM_REGEX.exec(date);
  if (!result) return null;

  var _result2 = _slicedToArray(result, 3),
      year = _result2[1],
      month = _result2[2];

  return {
    year: year,
    month: month,
    day: ''
  };
}), _defineProperty(_maskRemoveByFormat, FORMAT_YYYYMMDD, function (date) {
  var result = FORMAT_YYYYMMDD_REGEX.exec(date);
  if (!result) return null;

  var _result3 = _slicedToArray(result, 4),
      year = _result3[1],
      month = _result3[2],
      day = _result3[3];

  return {
    year: year,
    month: month,
    day: day
  };
}), _maskRemoveByFormat);

var DateInput = /*#__PURE__*/function (_Component) {
  _inherits(DateInput, _Component);

  function DateInput(props) {
    var _this;

    _classCallCheck(this, DateInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateInput).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getDateByKey", function (key) {
      var date = _this.state.date;
      return date[key];
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (inputValue, key, event) {
      if (isValidInteger(inputValue)) {
        var date = _objectSpread({}, _this.state.date, _defineProperty({}, key, inputValue));

        var value = maskAddByFormat[_this.props.format](date);

        _this.setState({
          date: date
        });

        eventBus.dispatch({
          type: 'onChange',
          component: 'DateInput',
          value: value,
          name: _this.props.name
        });

        _this.props.onChange({
          value: value,
          event: event
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e) {
      if (_this.props.onBlur) {
        isBlurringOutsideRefs(e, _this.inputRefs).then(function (result) {
          if (result) _this.props.onBlur(e);
        });
      }
    });

    _this.state = {
      date: {
        day: '',
        month: '',
        year: ''
      }
    };
    _this.isShortYear = props.format === 'YY-MM';
    _this.inputRefs = {
      day: React.createRef(),
      month: React.createRef(),
      year: React.createRef()
    };
    return _this;
  }

  _createClass(DateInput, [{
    key: "handleKeyDown",
    value: function handleKeyDown(e, nextField, prevField) {
      if (nextField) {
        if (e.target.selectionStart === e.target.value.length && e.keyCode === KEYCODE_RIGHT_ARROW) {
          e.preventDefault();
          this.inputRefs[nextField].current.focus();
          this.inputRefs[nextField].current.setSelectionRange(0, 0);
        }
      }

      if (prevField && e.target.selectionEnd === 0 && (e.keyCode === KEYCODE_BACKSPACE || e.keyCode === KEYCODE_LEFT_ARROW)) {
        e.preventDefault();
        var end = this.inputRefs[prevField].current.value.length;
        this.inputRefs[prevField].current.focus();
        this.inputRefs[prevField].current.setSelectionRange(end, end);
      }
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(e, nextField) {
      var maxLength = parseInt(e.target.getAttribute('maxLength'), 10);
      var isNumber = e.keyCode >= 48 && e.keyCode <= 57 || // Number keys
      e.keyCode >= 96 && e.keyCode <= 105; // Numpad number keys

      if (nextField && !this.inputRefs[nextField].current.value.length && e.target.value.length === maxLength && isNumber) {
        this.inputRefs[nextField].current.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _omit = omit(['onChange', 'value'], this.props),
          format = _omit.format,
          textMap = _omit.textMap,
          name = _omit.name,
          onBlur = _omit.onBlur,
          invalid = _omit.invalid,
          required = _omit.required,
          describers = _omit.describers,
          marginBottom = _omit.marginBottom,
          rest = _objectWithoutProperties(_omit, ["format", "textMap", "name", "onBlur", "invalid", "required", "describers", "marginBottom"]);

      return React.createElement("div", _extends({
        className: cn(styles.DateInput, getMarginBottomClass(marginBottom))
      }, rest), ![FORMAT_YYMM, FORMAT_YYYYMM, FORMAT_YYYY].includes(format) && React.createElement("div", {
        className: styles.day
      }, React.createElement("label", {
        className: styles.label,
        htmlFor: "".concat(name, "-date-day-field")
      }, textMap.day), React.createElement(NumberInput, {
        fullWidth: true,
        marginBottom: 0,
        maxLength: 2,
        name: "".concat(name, "-date-day"),
        onBlur: onBlur ? this.handleBlur : null,
        onChange: function onChange(_ref) {
          var value = _ref.value,
              event = _ref.event;
          return _this2.handleChange(value, 'day', event);
        },
        onKeyDown: function onKeyDown(e) {
          return _this2.handleKeyDown(e, 'month', null);
        },
        onKeyUp: function onKeyUp(e) {
          return _this2.handleKeyUp(e, 'month');
        },
        ref: this.inputRefs.day,
        value: this.getDateByKey('day'),
        invalid: invalid,
        required: required,
        describers: describers
      }), React.createElement("span", {
        "aria-hidden": "true",
        className: styles.separator
      }, "/")), format !== FORMAT_YYYY && React.createElement("div", {
        className: styles.month
      }, React.createElement("label", {
        className: styles.label,
        htmlFor: "".concat(name, "-date-month-field")
      }, textMap.month), React.createElement(NumberInput, {
        fullWidth: true,
        marginBottom: 0,
        maxLength: 2,
        name: "".concat(name, "-date-month"),
        onBlur: this.handleBlur,
        onChange: function onChange(_ref2) {
          var value = _ref2.value,
              event = _ref2.event;

          _this2.handleChange(value, 'month', event);
        },
        onKeyDown: function onKeyDown(e) {
          return _this2.handleKeyDown(e, 'year', format === FORMAT_YYYYMMDD && 'day');
        },
        onKeyUp: function onKeyUp(e) {
          return _this2.handleKeyUp(e, 'year');
        },
        ref: this.inputRefs.month,
        value: this.getDateByKey('month'),
        invalid: invalid,
        required: required,
        describers: describers
      }), React.createElement("span", {
        "aria-hidden": "true",
        className: styles.separator
      }, "/")), React.createElement("div", {
        className: this.isShortYear ? styles.shortYear : styles.year
      }, React.createElement("label", {
        className: styles.label,
        htmlFor: "".concat(name, "-date-year-field")
      }, textMap.year), React.createElement(NumberInput, {
        fullWidth: true,
        marginBottom: 0,
        maxLength: this.isShortYear ? 2 : 4,
        name: "".concat(name, "-date-year"),
        onBlur: this.handleBlur,
        onChange: function onChange(_ref3) {
          var value = _ref3.value,
              event = _ref3.event;
          return _this2.handleChange(value, 'year', event);
        },
        onKeyDown: function onKeyDown(e) {
          return _this2.handleKeyDown(e, null, format !== FORMAT_YYYY && 'month');
        },
        ref: this.inputRefs.year,
        value: this.getDateByKey('year'),
        invalid: invalid,
        required: required,
        describers: describers
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.value === state.lastValue) return null;
      var date = maskRemoveByFormat[props.format](props.value);

      if (!date || +date.year === +state.date.year && +date.month === +state.date.month && +date.day === +state.date.day) {
        return {
          lastValue: props.value
        };
      }

      return {
        date: date,
        lastValue: props.value
      };
    }
  }]);

  return DateInput;
}(Component);

_defineProperty(DateInput, "defaultProps", {
  value: '',
  format: FORMAT_YYYYMMDD,
  textMap: {
    day: 'Day',
    month: 'Month',
    year: 'Year'
  },
  invalid: false,
  required: true,
  marginBottom: 0
});

DateInput.propTypes = process.env.NODE_ENV !== "production" ? {
  format: PropTypes.oneOf([FORMAT_YYYY, FORMAT_YYYYMM, FORMAT_YYMM, FORMAT_YYYYMMDD]),
  textMap: PropTypes.shape({
    day: PropTypes.node,
    month: PropTypes.node,
    year: PropTypes.node
  }),

  /** docgen-from-context:<Fieldset/> */
  name: PropTypes.string,

  /** docgen-from-context:<Fieldset/> */
  onBlur: PropTypes.func,

  /**
   * docgen-from-context:<Fieldset/>
   * ---
   * proxied to eventBus
   */
  onChange: PropTypes.func.isRequired,

  /** docgen-from-context:<Fieldset/> */
  value: PropTypes.string,

  /** docgen-from-context:<Fieldset/> */
  invalid: PropTypes.bool,

  /** docgen-from-context:<Fieldset/> */
  required: PropTypes.bool,

  /** docgen-from-context:<Fieldset/> */
  describers: PropTypes.string,

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels)
} : {};
var DateInput$1 = withContext(Consumer, pick(['name', 'value', 'onChange', 'onBlur', 'invalid', 'required', 'describers']))(DateInput);
export default DateInput$1;
export { DateInput, FORMAT_YYMM, FORMAT_YYMM_REGEX, FORMAT_YYYY, FORMAT_YYYYMM, FORMAT_YYYYMMDD, FORMAT_YYYYMMDD_REGEX, FORMAT_YYYYMM_REGEX, FORMAT_YYYY_REGEX, KEYCODE_BACKSPACE, KEYCODE_LEFT_ARROW, KEYCODE_RIGHT_ARROW, maskAddByFormat, maskRemoveByFormat, yearRangeMax };